import { PlanType } from "./plan-type";

export enum UserLimit {
    Starter = 5,
    Trial = 10,
    Business = 100,
    ThirdParty = 1000000,
    Core = 30,
    Pro = 125,
    Enterprise = 250,
}

export const UserLimitPlanType: { [key: number | PlanType]: UserLimit } = {
    [PlanType.Business]: UserLimit.Business,
    [PlanType.Trial]: UserLimit.Trial,
    [PlanType.Core]: UserLimit.Core,
    [PlanType.Pro]: UserLimit.Pro,
}